import "./ProjectHeroEasyServices.scss";

function ProjectHeroEasyServices() {
  return (
    <>
      <section class="project-cs-hero">
        <div class="project-cs-hero__content">
          <h1 class="heading-primary">EasyServices</h1>
          <div class="project-cs-hero__info">
            <p class="text-primary text-primary--project">
              This is a web-based application for indiviual service providers to
              register and leverage their skills to help people out with.
            </p>
          </div>
          <div class="project-cs-hero__cta">
            <a
              href="https://easyservices.netlify.app/login"
              class="btn btn--bg"
              target="_blank"
              rel="noreferrer"
            >
              Live Link
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectHeroEasyServices;
